import { createFileRoute, redirect } from '@tanstack/react-router'
import { LocationsScreen } from '@/features/inventory-locations/locations-screen'
import { hasGrant } from '@/lib/me'

export const Route = createFileRoute('/_authenticated/inventory/locations')({
  beforeLoad: ({ context }) => {
    if (!hasGrant(context.queryClient, 'stock_location.view')) throw redirect({ to: '/' })
  },
  component: LocationsScreen,
})
